<mat-form-field
  class="w-100"
  *ngIf="!readonly"
  [floatLabel]="'always'"
  [ngClass]="{ 'no-label': hideLabel }"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label
    }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon
      [hidden]="!tooltipText"
      [matTooltip]="tooltipText"
      [matTooltipPosition]="'after'"
      [attr.aria-label]="'Tooltip: ' + tooltipText"
      tabindex="0"
    >
      help
    </mat-icon>
  </mat-label>
  <input
    #ssnInput
    matInput
    [attr.data-automation-id]="dataAutomationId"
    [placeholder]="placeholder"
    [formControl]="formControl"
    [ngModel]="formInfo.formGroup.value.ssn | ssnmask: false"
    type="password"
    [mask]="fgInfo.mask"
    (focus)="onFocus()"
    (focusout)="onFocusOut()"
    [readonly]="readonly || getReadonly()"
    [required]="fgInfo.required"
  />
  <button
    [attr.data-automation-id]="dataAutomationId"
    type="button"
    matSuffix
    mat-button
    (click)="toggleEditSsn()"
    *ngIf="showEdit()"
    style="font-size: 0.875rem !important;"
  >
    Edit
  </button>
  <mat-hint *ngIf="hasMask && !hint; else noMask">{{ placeholder }}</mat-hint>
  <ng-template #noMask>
    <mat-hint>{{ hint }}</mat-hint>
  </ng-template>
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly">
  <div class="row">
    <div class="col-8">
      <mat-form-field
        class="no-underline w-100"
        [floatLabel]="'always'"
        [ngClass]="{ 'read-only': readonly, 'no-label': hideLabel }"
      >
        <mat-label>{{ fgInfo.label }}</mat-label>
        <input
          readonly
          matInput
          [attr.data-automation-id]="dataAutomationId"
          [ngModel]="formInfo.formGroup.value.ssn | ssnmask: true"
          tabindex="-1"
        />
      </mat-form-field>
    </div>
    <div class="col-4">
      <button
        type="button"
        matSuffix
        mat-button
        color="secondary"
        (click)="getReadonly()"
        *ngIf="showViewSSNButton && hasSSN"
      >
        View SSN
      </button>
    </div>
  </div>
</ng-container>
